import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ReportResponseService } from '../../services/report_response.service';
import { PeriodService } from '../../../periods/period.service';
import { ReportStatesService } from '../../../shared/services/report_states.service';
import { LicenseService } from '../../../user/services/license.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-reports-review',
  templateUrl: './reports-review.component.html',
  styleUrl: './reports-review.component.scss'
})
export class ReportsReviewComponent {
  reports: any[] = []
  periods: any[] = []
  reportstates: any[] = []
  missionarylicenses: any[] = [];

  // Paginación 
  currentPage: number = 1;
  pageSize: number = 10;
  totalRecords: number = 0;
  totalPages: number = 0; // Ahora tomamos esto desde la API/*  */

  //filtros de busqueda
  username: string = '';
  periodId: string = '';
  licenseId: string = '';
  stateId: string = '';


  constructor(
    private router: Router,
    private reportResponseService: ReportResponseService,
    private periodService: PeriodService,
    private reportStatesService: ReportStatesService,
    private licenseService: LicenseService
  ) { }

  loadReports(): void {
    Swal.fire({
      title: 'Cargando Reportes...',
      html: 'Por favor espera',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.reportResponseService.getView(
      {
        page: this.currentPage,
        limit: this.pageSize,
        username: this.username,
        periodId: this.periodId,
        licenseId: this.licenseId,
        stateId: this.stateId
      }
    ).subscribe({
      next: (response) => {
        this.reports = response.ReportResponses;
        this.totalRecords = response.total;
        this.totalPages = response.totalPages;
        Swal.close();
      },
      error: (error) => {
        Swal.close()
        console.error("Error al cargar los reportes:", error);
      }
    });
  }

  loadPeriods(): void {
    this.periodService.get().subscribe({
      next: (response) => {
        this.periods = response;
      },
      error: (error) => {
        console.error("Error al cargar los periodos:", error);
      }
    });
  }

  loadLicenses(): void {
    this.licenseService.get().subscribe({
      next: (response) => {
        this.missionarylicenses = response;
      },
      error: (error) => { console.log(error) }
    });
  }

  loadReportStates(): void {
    this.reportStatesService.get().subscribe({
      next: (response) => {
        this.reportstates = response;
      },
      error: (error) => {
        console.error("Error al cargar los estados de reportes:", error);
      }
    });
  }

  onSearch() {
    this.currentPage = 1; // Reiniciar la paginación en la primera página
    this.loadReports();
  }

  ngOnInit(): void {
    this.loadPeriods();
    this.loadReportStates();
    this.loadLicenses();
    this.loadReports(); // Cargar los reportes al iniciar el componente
  }

  onEdit(id: String, openNewTab: boolean = false) {
    if (openNewTab) {
      const url = this.router.createUrlTree(['expense-reports/report-review', id]).toString();
      window.open(url, '_blank');
    } else {
      this.router.navigate(['expense-reports/report-review', id]);
    }
  }

  onPageSizeChange() {
    this.currentPage = 1; // Reiniciar a la primera página
    this.loadReports(); // Recargar los usuarios con el nuevo pageSize
  }

  changePage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.loadReports();
  }

  getPaginationArray(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  generateResumeDependents() {
    this.reportResponseService.generateResumeDependents(this.periodId).subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'resumen-conceptos.xlsx';
      link.click();
      window.URL.revokeObjectURL(url);
    });
  }

    generateResumeIndependents() {
    console.log(this.periodId);
    this.reportResponseService.generateResumeIndependents(this.periodId).subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'resumen-conceptos.xlsx';
      link.click();
      window.URL.revokeObjectURL(url);
    });
  }

  

}
